<template>
	<LayoutMap>
		<template #actions>
			<Button
				secondary
				text="voltar"
			/>
			<Button text="Concluir" />
		</template>
		<Mapa
			:geojson="geojson"
			:markers="parcelasGeradas"
		/>
		<CardFinalizacao :ordem-servico="ordemServico" />
		<template #colapsable>
			<Collapsible
				ref="collapsible"
				class="max-w-sm"
				vertical
			>
				<div class="flex flex-col pl-8 pr-4 gap-6 pt-2 max-w-lg">
					<p>Para lançar as parcelas, preencha as informações e escolha os filtros desejados</p>
					<FormPlanejamentoOrdemServico
						@lancar="lancarParcelas"
						@limpar="limparPlanejamento"
					/>
				</div>
			</Collapsible>
		</template>
	</LayoutMap>
</template>

<script lang="ts" setup>
import { useElementSize, useLocalStorage } from '@vueuse/core'
import { onMounted, ref, watch } from 'vue'
import Button from '../../../components/ui/button/Button.vue'
import Collapsible from '../../../components/ui/collapsible/Collapsible.vue'
import Mapa from '../../../components/ui/mapa/Mapa.vue'
import { usePlanejamentoOrdemServico } from '../../../composables/usePlanejamentoOrdemServico'
import LayoutMap from '../../../layouts/LayoutMap.vue'
import CardFinalizacao from './CardFinalizacao.vue'
import FormPlanejamentoOrdemServico from './FormPlanejamentoOrdemServico.vue'
const collapsible = ref(null)
const storageRecuo = useLocalStorage('storageRecuo', 0)
const {
	ordemServico,
	getPlanejamentoOrdemServico,
	geojson,
	lancarParcelas,
	parcelasGeradas,
	limparPlanejamento,
} = usePlanejamentoOrdemServico()

const { width } = useElementSize(collapsible)
watch(width, () => {
	storageRecuo.value = ((width.value - 15) / window.innerWidth) * 100
})

onMounted(() => {
	getPlanejamentoOrdemServico()
})
</script>

<style></style>
